<h2>Выбор региона</h2>
<ul>
  <li *ngFor="let customerGroup of customerGroups$ | async"
      (click)="select(customerGroup)" [ngClass]="selectedGroup && customerGroup.id === selectedGroup.id ? 'selected' : ''" [textContent]="customerGroup.header">
  </li>
</ul>
